import { defineMessages } from 'react-intl';

export const messages: {
	dismissMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assetsAsAnAppBannerText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dismissMessage: {
		id: 'assets-app-message-banner-dismiss-message',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the assets app banner',
	},
	assetsAsAnAppBannerText: {
		id: 'assets-app-message-banner-available-soon',
		defaultMessage:
			'<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.',
		description: 'Text for banner appearing above search results',
	},
});
